module.exports = __webpack_public_path__ + "ath_game_web/img/7.4.323937f3.png";